import { Box, Skeleton, Typography } from "@mui/material";
import { StyledCard } from "./components/StyledComponents";
import { useBaseEntityInfo } from "../../Hooks/usePagesContent";

/**
 * Custom platform TotalVehiclesCard.
 *
 * Difference from Coulomb version: shows only the total count.
 * The Operational / Non-Operational breakdown is not shown.
 */
const TotalVehiclesCard = ({ stats, loading }) => {
  const { total: totalCount } = stats;
  const { baseEntityTypePluralLable } = useBaseEntityInfo();

  return (
    <StyledCard>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%", gap: 1.5 }}>
        <Typography variant="fw500s16lh20c000000">
          Total {baseEntityTypePluralLable}
        </Typography>
        <Box sx={{ display: "flex", flex: 1, alignItems: "center", justifyContent: "center" }}>
          {loading ? (
            <Skeleton variant="text" width={64} height={56} />
          ) : (
            <Typography
              variant="fw500s20c000000"
              sx={{ fontSize: "48px", lineHeight: "56px" }}
            >
              {totalCount ?? "-"}
            </Typography>
          )}
        </Box>
      </Box>
    </StyledCard>
  );
};

export default TotalVehiclesCard;
